import { Button, Grid } from "@material-ui/core"
import { ConfirmDialogPropsScroll, ConfirmDialogPropsSize } from "../../js/types"
import { ConfirmDialogTS } from "../../_AAA/components/ReactDialogTS"
import { ReactOutlineDatePicker, ReactOutlineInput } from "../../_AAA/components/ReactTextField"
import { useState } from "react"
import { MessageSearch } from "."
import { HintType, messageSearchFields } from "./consts"
import { createHandleInput } from "../../js/function"
import { createSchema, field, validateData } from "../../js/Validator"


interface ModalHintBellSearchSettingsProps {
    hintType: HintType,
    searchOptions: MessageSearch[HintType],
    searchSettingsModalConfirm: (type: HintType, message: MessageSearch[HintType]) => void,
    modalClose: () => void,
}

const ModalHintBellSearchSettings = (props: ModalHintBellSearchSettingsProps) => {

    const { searchOptions, searchSettingsModalConfirm, modalClose } = props

    const [pageSearch, setPageSearch] = useState<MessageSearch[HintType]>(searchOptions)
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    const searchHandleInput = createHandleInput(setPageSearch, () => ({ page: 1 }));

    const handleModalConfirm = () => {

        // 檢查欄位是否有錯誤
        const schema = createSchema<MessageSearch[HintType]>({
            valid_date_start: field<string>().checkDateTimeRange('valid_date_start', 'valid_date_end'),
            valid_date_end: field<string>().checkDateTimeRange('valid_date_start', 'valid_date_end'),
        });
        const isValid = validateData(schema, pageSearch, setErrors);
        if (isValid) {
            searchSettingsModalConfirm(HintType.BULLTIN, pageSearch)
        }
    }

    return (<ConfirmDialogTS
        modalOpen={true}
        closeClick={() => modalClose()}
        modal={{
            id: "settingsModal",
            modaltitle: "進階搜尋篩選條件",
            size: ConfirmDialogPropsSize.XS,
            scroll: ConfirmDialogPropsScroll.BODY,
            modalBtnGroup: (
                <div>
                    <Button color="primary" type="button" onClick={modalClose}>
                        取消
                    </Button>
                    <Button className="MuiOtherButton" color="primary" type="button" onClick={handleModalConfirm}>
                        確認
                    </Button>
                </div>
            ),
            messages: <Grid container>
                <Grid item lg={12} md={12} xs={12}>
                    {Object.entries(messageSearchFields).map(([key, item]) => {
                        const { title, fieldtype } = item;
                        if (fieldtype === 'date') {
                            return (
                                <ReactOutlineDatePicker
                                    key={`search--${key}-${title}`}
                                    color="primary"
                                    id={`search--${key}`}
                                    name={`search--${key}`}
                                    matchFrom={"any"}
                                    showTodayButton={true}
                                    placeholder="無"
                                    label={title}
                                    value={pageSearch[key as keyof typeof pageSearch]}
                                    changeEvent={searchHandleInput}
                                    errorText={errors?.[key]}
                                />)
                        } else {
                            return (
                                <ReactOutlineInput
                                    key={`search--${key}-${title}`}
                                    color="primary"
                                    type="text"
                                    id={`search--${key}`}
                                    name={`search--${key}`}
                                    changeEvent={searchHandleInput}
                                    value={pageSearch[key as keyof typeof pageSearch]}
                                    label={title}
                                    errorText={errors?.[key]}
                                    placeholder="尚未輸入" />
                            );
                        }
                    })}
                </Grid>
            </Grid>
        }} />)
}

export default ModalHintBellSearchSettings;